<template>
  <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
    <v-list two-line >
      <template v-for="(order,index) in orders">
        <v-list-tile
                :key="index"
                :to="'/orderDetail/?orderId='+order.orderId"

        >
          <v-list-tile-content>
            <v-list-tile-title >{{serviceName(order)}}</v-list-tile-title>
            <v-list-tile-sub-title>{{orderDayTime(order)}}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>arrow_forward</v-icon>
          </v-list-tile-action>

        </v-list-tile>
      </template>
    </v-list>
  </v-flex>
</template>
<script>
  import  { Logger } from 'aws-amplify';
  const logger = new Logger('History','INFO');
  import { AmplifyEventBus } from 'aws-amplify-vue'
  import moment from 'moment-timezone'

  export default {
    mounted(){
      AmplifyEventBus.$emit('setBackTo', "/")
      this.trackPage('/history/')
      if(localStorage.getItem('orders')){
        this.orders = JSON.parse( localStorage.getItem('orders') )
        this.orders.sort(this.sortOrders)
        logger.info("orders",this.orders)
        for(let i in this.orders){
          const order = this.orders[i]
          if(!order.orderId && order.deliveryProvider){
            //logger.info("no id found",order)
            let orderId = ""
            const orderAnyStr = order.deliveryProvider.chargeJobsResult[0]
            //logger.info("orderAnyStr",orderAnyStr.orderUuid)
            if(orderAnyStr.orderUuid.slice(-3) == "_dp"){
              orderId = orderAnyStr.orderUuid.slice(0,-3)
            }else{
              orderId = orderAnyStr.orderUuid
            }
            order.orderId = orderId
          }
        }
        if(this.orders.length){
          this.orders = this.orders.reverse()
        }
      }
      AmplifyEventBus.$emit('setJourney', {key:"page",value:"ご注文履歴"} )
    },
    data(){
      return{
        orders:[],

      }
    },
    methods: {
      sortOrders:function(a,b){
        if(!a.userSelect
          || !a.userSelect.day
          || !a.userSelect.day.dayText
          || !a.userSelect.time
          || !b.userSelect
          || !b.userSelect.day
          || !b.userSelect.day.dayText
          || !b.userSelect.time
        ){
          //logger.info("no sufficient data to sort")
          //logger.info(a)
          //logger.info(b)
          //logger.info(a.userSelect.day)
          //logger.info(a.userSelect.day.dayText)
          //logger.info(a.userSelect.time)

          //logger.info(b.userSelect)
          return 0
        }

        const dateAstr = a.userSelect.day.dayText + "T" + a.userSelect.time+":00+09:00"
        const dateA = moment(dateAstr).unix()
        const dateBstr = b.userSelect.day.dayText + "T" + b.userSelect.time+":00+09:00"
        const dateB = moment(dateBstr).unix()
        //logger.info("comparing "+dateA+" "+dateB)
        let comparison = 0
        if(dateA > dateB){
          comparison = 1
        }else if(dateA < dateB){
          comparison = -1
        }
        return comparison
      },
      getDpOrders:function(order){
        if(order.deliveryProvider && order.deliveryProvider.chargeJobsResult){
          // it is dp order
          const dpOrders = {}
          for(let i in order.deliveryProvider.chargeJobsResult){
            const singleOrder = order.deliveryProvider.chargeJobsResult[i]

            if(singleOrder.orderUuid.slice(-3)=="_dp"){
              dpOrders.dp = singleOrder
            }else{
              dpOrders.shop = singleOrder
            }
          }
          return dpOrders
        }else{
          return {}
        }
      },
      serviceName:function(order){
        let res = ""
        if(order.userSelect
                && order.userSelect.service
                && order.userSelect.service.langName){
          res += order.userSelect.service.langName + ""
        }
        if(order.premiseName){
          res += order.premiseName
        }

        const dpOrders = this.getDpOrders(order)
        if(dpOrders.dp){
          //logger.info("dpOrders",dpOrders)
          res = ""
          res += "お届け "
          if(dpOrders.dp.chargeResult.premiseName){
            res += dpOrders.dp.chargeResult.premiseName
          }
        }


        return res
      },
      orderDayTime:function(order){
        let res = ""
        if(order.userSelect
                && order.userSelect.day
                && order.userSelect.day.dayTextLang){
          res += order.userSelect.day.dayTextLang + ""
        }
        if(order.userSelect
                && order.userSelect.time){
          res += order.userSelect.time
        }

        const dpOrders = this.getDpOrders(order)
        if(dpOrders.dp){
          logger.info("dpOrders",dpOrders)
          res = ""
          if(dpOrders.dp.chargeResult.originalDataSent.dataToSend.userSelect){
            const userSelect = dpOrders.dp.chargeResult.originalDataSent.dataToSend.userSelect
            res += userSelect.deliveryDay.dayTextLang
            res += " "
            res += userSelect.deliveryTime.eta
          }

        }


        return res
      }
    },
    computed:{



    },
  }
</script>
